import { render, staticRenderFns } from "./user_center_teacher.vue?vue&type=template&id=50cd82bf&scoped=true&"
import script from "./user_center_teacher.vue?vue&type=script&lang=js&"
export * from "./user_center_teacher.vue?vue&type=script&lang=js&"
import style0 from "./user_center_teacher.css?vue&type=style&index=0&id=50cd82bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd82bf",
  null
  
)

export default component.exports